export enum Experiment {
  ViewerCustomProfile = 'specs.membersArea.viewerCustomProfile',
  CustomProfile = 'specs.membersArea.customProfile',
  UseLocalizationService = 'specs.customFields.UseLocalizationService',
  OOIInEditor = 'specs.membersArea.framelessEditorMyAccount',
  MemberBlockMember = 'specs.membersArea.MemberBlockMember',
}
